module.exports = __webpack_public_path__ + "img/placeholder.a28bc24.jpg";